import {IServiceFactory} from "../../../../service-factory.interface";
import {SpecialAssistanceSsrBase} from "../special-assistance-ssr-base";

export default class DpnaSsrType extends SpecialAssistanceSsrBase {
    constructor(services: IServiceFactory) {
        super('DPNA', services);
    }
}
